import {
    FAMILY_FIELDS,
    PATENT_FIELDS_MAP,
    CUSTOMFIELD_SORT_TYPE_MAP,
    WS_CREATED_AT,
} from './constant';

import _ from 'lodash';
const { map, forEach, compact, get, find } = _;
// {
//     key: '排序的key', // 如 desc
//     fieldStructure: {
//         key: '字段key' // 如 APN
//         label: '字段文案' // 如 专利价值
//         field_type: '自定义字段类型' // 如 STRING
//         options: ['新-旧', '旧-新'] // 排序key 如 ['pndesc', 'pnasc']
//         sortType: 'NUMBER' // 字段种类 用于显示描述 如 NUMBER则显示 9-1 , 1-9;
//     },
//     type: '排序属于哪个类型', // CUSTOMFIELD
// }
class AdvanceSort {
    constructor() {
        this.patentFieldStructureList = [];
        this.customFieldStructureList = [];
        this.familyFieldStructureList = [];

        this.patentFieldStructureKeyMap = {};
        this.customFieldStructureKeyMap = {};
        this.familyFieldStructureKeyMap = {};

        this.patentFields = [];
        this.customFields = [];
        this.supportFieldType = [
            'PATENT', 'CUSTOMFIELD', 'FAMILY'
        ];

        this.sortInfo = null;

        this.vm = null;
        this.inited = false;
        this.maxSortFieldNumber = 3;

        this.enableCustomFieldFun = true;
    }

    init({
        patentFields,
        customFields,
        supportFieldType,
        vm,
        enableCustomFieldFun,
    }) {
        if (vm && vm._isDestroyed) {
            return;
        }
        this.patentFields = patentFields;
        this.customFields = customFields;
        this.enableCustomFieldFun = enableCustomFieldFun;
        this.vm = vm;

        if (supportFieldType) {
            this.supportFieldType = supportFieldType;
        }

        this.patentFieldStructureList = this.transformPatentFields(this.patentFields);
        this.customFieldStructureList = this.transformCustomfields(this.customFields);
        this.familyFieldStructureList = this.transformFamilyFields(FAMILY_FIELDS);
        this.patentFieldStructureKeyMap = this.reverseFieldOptionsKey(this.patentFieldStructureList);
        this.customFieldStructureKeyMap = this.reverseFieldOptionsKey(this.customFieldStructureList);
        this.familyFieldStructureKeyMap = this.reverseFieldOptionsKey(this.familyFieldStructureList);

        if (!this.supportFieldType.includes('CUSTOMFIELD')) {
            this.customFieldStructureList = [];
            this.customFieldStructureKeyMap = {};
        }

        if (!this.supportFieldType.includes('FAMILY')) {
            this.familyFieldStructureList = [];
            this.familyFieldStructureKeyMap = {};
        }

        this.inited = true;
    }

    update() {
        if (!this.vm || !this.vm.$t) return false;
        this.init({
            patentFields: this.patentFields,
            customFields: this.customFields,
            vm: this.vm,
        });
    }

    getSortKeyType(key) {
        if (this.patentFieldStructureKeyMap[key]) {
            return 'PATENT';
        }
        if (this.customFieldStructureKeyMap[key]) {
            return 'CUSTOMFIELD';
        }
        if (this.familyFieldStructureKeyMap[key]) {
            return 'FAMILY';
        }
    }

    isSortKeySupport(sortKey) {
        const sorts = _.compact((sortKey || '').split(','));
        return _.every(sorts, (sort) => {
            return !!this.getSortKeyType(sort);
        })
    }

    getFieldKeyFieldStructure(key) {
        return find(this.patentFieldStructureList, { key }) || find(this.customFieldStructureList, { key })
    }

    getSortKeyFieldStructure(key) {
        return this.patentFieldStructureKeyMap[key] || this.customFieldStructureKeyMap[key] || this.familyFieldStructureKeyMap[key];
    }

    transformPatentFields(patentFields) {
        const { vm } = this;
        return map(patentFields, key => {
            return {
                ...PATENT_FIELDS_MAP[key],
                label: (() => {
                    let i18nKey = key;
                    if (i18nKey === 'PRIORITY') {
                        i18nKey = 'FIRST_FADL_DATE';
                    }
                    if (vm.$te(`commonPatent.BASIC.${i18nKey}`)) {
                        return vm.$t(`commonPatent.BASIC.${i18nKey}`);
                    }
                    if (vm.$te(`advanceSort.extendFields.${i18nKey}`)) {
                        return vm.$t(`advanceSort.extendFields.${i18nKey}`);
                    }
                    return key;
                })()
            };
        });
    }

    transformCustomfields(customfields) {
        const { vm } = this;
        const fields = compact(map(customfields, ({ field_id, field_name, field_type }) => {
            if (!CUSTOMFIELD_SORT_TYPE_MAP[field_type]) return null;
            return {
                key: field_id,
                label: field_name,
                field_type,
                options: [
                    `${field_id}:asc`,
                    `${field_id}:desc`
                ],
                sortType: CUSTOMFIELD_SORT_TYPE_MAP[field_type],
            };
        }));

        return [
            {
                ...WS_CREATED_AT,
                field_type: 'DATE',
                label: vm.$t('commonPatent.BASIC.WS_CREATED_AT'),
            },
            ...fields,
        ];
    }

    transformFamilyFields(familyFields) {
        const { vm } = this;
        return [
            {
                key: 'SORT_SEQ_NUM',
                label: vm.$t('advanceSort.extendFields.SORT_SEQ_NUM'),
                options: familyFields,
                sortType: 'FAMILY',
            }
        ];
    }

    reverseFieldOptionsKey(fields) {
        if (!fields || !fields.length) {
            return [];
        }
        const sortKeyMap = {};
        forEach(fields, (field) => {
            forEach(field.options, (sortKey) => {
                sortKeyMap[sortKey] = field;
            });
        });
        return sortKeyMap;
    }

    getSortKeyDirection(sortKey) {
        const { vm } = this;
        if (vm && vm._isDestroyed) {
            return;
        }

        const fieldStructure = this.getSortKeyFieldStructure(sortKey);

        if (fieldStructure.sortType === 'FAMILY') {
            return {
                sortKey,
                label: null,
                index: 1,
                fieldStructure,
            };
        }
        const index = fieldStructure.options.indexOf(sortKey);
        const label = vm.$t(`advanceSort.sortType.${fieldStructure.sortType}[${index}]`);

        return {
            sortKey,
            label,
            index,
            fieldStructure,
        };
    }

    serializeSortString(sortKey) {
        if (!sortKey) return null;
        const sortKeys = compact(sortKey.split(','));
        const sortMap = {};
        const sorts = map(sortKeys, (sortKey, index) => {
            const item = {
                sortIndex: index,
                sortKey,
                direction: this.getSortKeyDirection(sortKey),
                fieldStructure: this.getSortKeyFieldStructure(sortKey),
            };
            sortMap[item.fieldStructure.key] = item;
            return item;
        });

        this.sortInfo = {
            sorts,
            sortMap,
        };

        return this.sortInfo;
    }

    getFieldSortedInfo(key) {
        const sorts = get(this, 'sortInfo.sorts');

        // 单排序的时候不显示 表头的数字
        if (sorts && sorts.length === 1) return null;

        return get(this, `sortInfo.sortMap.${key}`);
    }
}

export default new AdvanceSort();
